import { useState } from "react";
import Button from "@mui/material/Button";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

const CaptchaButton = ({ onVerifyCaptcha }: any) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [disable, setDisable] = useState(false);
  const clickHandler = async () => {
    if (!executeRecaptcha) {
      return;
    }
    const token = await executeRecaptcha("forgetpassword");
    onVerifyCaptcha(token);
    setDisable(true);
  };

  return (
    <Button onClick={clickHandler} variant="outlined" disabled={disable}>
      Please validate you are a human.
    </Button>
  );
};

export const ReCaptcha = ({ onVerifyCaptcha }: any) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}
  >
    <CaptchaButton onVerifyCaptcha={onVerifyCaptcha} />
  </GoogleReCaptchaProvider>
);
